import React, { useState } from "react";

import {
  CloseButton,
  FilledButton,
  TextButton,
} from "components/common/Button/Button";
import Filter from "components/common/Inputs/Filter/Filter";
import FitlerGroup from "components/common/Inputs/FilterGroup/FilterGroup";
import {
  accessToTheCustomerOptions,
  clientTypesOptions,
  facilitateAccessOptions,
  genderOptions,
  paymentTypeOptions,
  priceOptions,
  salonTypesOptions,
} from "constants/filterOptions";
import { massageTypeFilterGroupOptions } from "constants/massageTypes";
import classes from "./MobileFiltersMenu.module.css";
import useTranslation from "next-translate/useTranslation";
import { AnnouncementFilters, AnnouncementFiltersKey } from "../Filters";
import PriceFilter from "../../../../common/Inputs/PriceFilter/PriceFilter";

type MobileFiltersMenuProps = {
  filterValues: AnnouncementFilters;
  categoriesFilter: {
    [key: string]: string | string[] | { [key: string]: string | string[] };
  };
  radioButtonFilterValueChangeHandler: (
    filterName: AnnouncementFiltersKey,
    value: string
  ) => void;
  checkboxFilterValueChangeHandler: (
    filterName: AnnouncementFiltersKey,
    value: string
  ) => void;
  changePriceFilterHandler: (value: string[]) => void;
  changeCategoryMainFilterHandler: (category: string) => void;
  changeCategorySubFilterHandler: (
    mainCategory: string,
    subCategory: string
  ) => void;
  submissionFilterHandler: () => void;
  closeMenuHandler: () => void;
  clearFiltersHandler: () => void;
  filtersCounter: number;
};

const MobileFiltersMenu = ({
  filterValues,
  categoriesFilter,
  submissionFilterHandler,
  radioButtonFilterValueChangeHandler,
  checkboxFilterValueChangeHandler,
  changePriceFilterHandler,
  changeCategoryMainFilterHandler,
  changeCategorySubFilterHandler,
  clearFiltersHandler,
  closeMenuHandler,
  filtersCounter,
}: MobileFiltersMenuProps) => {
  const [openFilters, setOpenFilters] = useState<{ [key: string]: boolean }>({
    categories: false,
    price: false,
    paymentMethods: false,
    accessToTheCustomer: false,
    genders: false,
    clientTypes: false,
    typeOfSalons: false,
    facilitateAccess: false,
  });
  const { t } = useTranslation("common");

  const clickToggleHandler = (filterName: string, openValue: boolean) => {
    setOpenFilters({
      ...{
        categories: false,
        price: false,
        paymentMethods: false,
        accessToTheCustomer: false,
        genders: false,
        clientTypes: false,
        typeOfSalons: false,
        facilitateAccess: false,
      },
      [filterName]: openValue,
    });
  };

  return (
    <div className={classes.mobileFiltersMenu}>
      <div className={classes.menuHeading}>
        <span>
          <span className={classes.headingText}>
            {t("missing:all_filters")}
          </span>{" "}
          {!!filtersCounter && (
            <span className={classes.counter}>{filtersCounter}</span>
          )}
        </span>
        <CloseButton onClick={closeMenuHandler} />
      </div>
      <div className={classes.menuContent}>
        <form>
          <ul>
            <li className={classes.input}>
              <FitlerGroup
                options={massageTypeFilterGroupOptions}
                selectedMainOptions={
                  categoriesFilter.mainCategories as string[]
                }
                selectedSubOptions={
                  categoriesFilter.subCategories as { [key: string]: string[] }
                }
                onChangeMainOptionHandler={changeCategoryMainFilterHandler}
                onChangeSubOptionHandler={changeCategorySubFilterHandler}
                placeholder={t("type_of_treatment")}
                onClickToggleHandler={clickToggleHandler}
                isFilterGroupOpen={openFilters.categories}
                filterGroupName="categories"
                closeOnClickOutside={false}
                onCloseMenuHandler={closeMenuHandler}
                mobileMode
              />
            </li>
            <li className={classes.input}>
              <PriceFilter
                selectedValue={filterValues.price as string[]}
                onChangeHandler={changePriceFilterHandler}
                placeholder={t("common:price")}
                filterName="price"
                isFilterOpen={openFilters.price}
                closeOnClickOutside={false}
                onClickToggle={clickToggleHandler}
                expandedInPlace
              />
              {/*<Filter*/}
              {/*   filterType="radioButton"*/}
              {/*   selectedOptions={filterValues.price as string[]}*/}
              {/*   onChangeHandler={radioButtonFilterValueChangeHandler}*/}
              {/*   options={priceOptions}*/}
              {/*   placeholder={t('price')}*/}
              {/*   filterName="price"*/}
              {/*   isFilterOpen={openFilters.price}*/}
              {/*   closeOnClickOutside={false}*/}
              {/*   onClickToggle={clickToggleHandler}*/}
              {/*   expandedInPlace*/}
              {/*/>*/}
            </li>
            <li className={classes.input}>
              <Filter
                filterType="checkbox"
                selectedOptions={filterValues.payment as string[]}
                onChangeHandler={checkboxFilterValueChangeHandler}
                options={paymentTypeOptions}
                placeholder={t("type_of_payment")}
                filterName="payment"
                isFilterOpen={openFilters.paymentMethods}
                closeOnClickOutside={false}
                onClickToggle={clickToggleHandler}
                expandedInPlace
              />
            </li>
            <li className={classes.input}>
              <Filter
                filterType="checkbox"
                selectedOptions={filterValues.accessToTheCustomer as string[]}
                onChangeHandler={checkboxFilterValueChangeHandler}
                options={accessToTheCustomerOptions}
                placeholder={t("drive_to_customer")}
                filterName="accessToTheCustomer"
                isFilterOpen={openFilters.accessToTheCustomer}
                closeOnClickOutside={false}
                onClickToggle={clickToggleHandler}
                expandedInPlace
              />
            </li>
            <li className={classes.input}>
              <Filter
                filterType="checkbox"
                selectedOptions={filterValues.genders as string[]}
                onChangeHandler={checkboxFilterValueChangeHandler}
                options={genderOptions}
                placeholder={t("sex_of_person_massaging")}
                filterName="genders"
                isFilterOpen={openFilters.genders}
                closeOnClickOutside={false}
                onClickToggle={clickToggleHandler}
                expandedInPlace
              />
            </li>

            <li className={classes.input}>
              <Filter
                filterType="checkbox"
                selectedOptions={filterValues.clientTypes as string[]}
                onChangeHandler={checkboxFilterValueChangeHandler}
                options={clientTypesOptions}
                placeholder={t("massage_for")}
                filterName="clientTypes"
                closeOnClickOutside={false}
                isFilterOpen={openFilters.clientTypes}
                onClickToggle={clickToggleHandler}
                expandedInPlace
              />
            </li>
            <li className={classes.input}>
              <Filter
                filterType="checkbox"
                selectedOptions={filterValues.typeOfSalons as string[]}
                onChangeHandler={checkboxFilterValueChangeHandler}
                options={salonTypesOptions}
                placeholder={t("facility_type")}
                filterName="typeOfSalons"
                closeOnClickOutside={false}
                isFilterOpen={openFilters.typeOfSalons}
                onClickToggle={clickToggleHandler}
                expandedInPlace
              />
            </li>
            <li className={classes.input}>
              <Filter
                filterType="checkbox"
                selectedOptions={filterValues.facilitateAccess as string[]}
                onChangeHandler={checkboxFilterValueChangeHandler}
                options={facilitateAccessOptions}
                placeholder={t("access_facilities")}
                filterName="facilitateAccess"
                closeOnClickOutside={false}
                isFilterOpen={openFilters.facilitateAccess}
                onClickToggle={clickToggleHandler}
                expandedInPlace
              />
            </li>
          </ul>
        </form>
      </div>
      <div className={classes.buttonsSection}>
        <FilledButton
          type="button"
          content={t("apply_filters")}
          onClick={submissionFilterHandler}
          className={classes.filledBtn}
        />
        <TextButton
          type="button"
          content={t("clear")}
          onClick={clearFiltersHandler}
          className={classes.outlinedBtn}
        />
      </div>
    </div>
  );
};

export default MobileFiltersMenu;
